import { render } from "./privateLayout.vue?vue&type=template&id=4dbe7d71&scoped=true"
const script = {}

import "./privateLayout.vue?vue&type=style&index=0&id=4dbe7d71&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dbe7d71"]])

export default __exports__